import { render, staticRenderFns } from "./CommodityAdvancedTable.vue?vue&type=template&id=2be6b16e&scoped=true&"
import script from "./CommodityAdvancedTable.vue?vue&type=script&lang=js&"
export * from "./CommodityAdvancedTable.vue?vue&type=script&lang=js&"
import style0 from "./CommodityAdvancedTable.vue?vue&type=style&index=0&id=2be6b16e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6b16e",
  null
  
)

export default component.exports